<template lang="pug">
  div
    table.table
      thead.table__header
        tr.table__row.table__row--head
          th.table__cell {{ 'base.name' | translate }}
          th.table__cell {{ 'base.type' | translate }}
          th.table__cell {{ 'base.edrpu' | translate }}
          th.table__cell {{ 'base.information' | translate }}
          th.table__cell(v-if="loaded && !!deliveryCompanies.length")
      v-table-body(
        :cols="4"
        :loading="!loaded"
        :empty="!deliveryCompanies.length")
        tr.table__row(
          v-for="item in deliveryCompanies"
          :key="item.id")
          td.table__cell {{ item.name }}
          td.table__cell {{ item.side === 'buyer' ? $t('base.buyer') : $t('base.seller') }}
          td.table__cell {{ item.ind_code }}
          td.table__cell {{ item.description }}
          td.table__cell.table__cell--action
            v-btn(
              :disabled="!hasPermission('delivery_company', 'change')"
              icon
              @click="openCompanyDetail(item.id)")
              i.i-util-settings

    //- ui-pagination(
      v-if="loaded"
      :count="totalCount"
      v-model="page"
      @page-change="loadData")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

// import UiPagination from '@/components/ui/ui-pagination/UiPagination'

export default {
  name: 'CompaniesTable',

  // components: {
  //   UiPagination
  // },

  mounted () {
    this.loadData()
  },

  data: () => ({
    loaded: false
    // page: 1
  }),

  methods: {
    ...mapActions('deliveries', [
      'loadCompanies',
      'openCompanyDetail'
    ]),

    async loadData () {
      const params = {
        farm: this.$route.params.farm_id
        // page: this.page
      }
      await this.loadCompanies(params)
      this.loaded = true
    }
  },

  computed: {
    ...mapGetters('deliveries', [
      'deliveryCompanies'
    ]),

    totalCount () {
      return this.deliveryCompanies.count !== undefined
        ? this.deliveryCompanies.count
        : this.deliveryCompanies.length
    }
  }

  // watch: {
  //   totalCount () {
  //     this.page = 1
  //   },

  //   page () {
  //     this.loaded = false
  //   }
  // }
}
</script>
<style scoped>
td.table__cell {
  white-space: nowrap; /* Prevents text from wrapping */
  overflow: hidden;    /* Hides overflowed content */
  text-overflow: ellipsis; /* Adds ellipsis for truncated text */
  max-width: 300px;    /* Set the max width based on the desired limit */
}
</style>